import { useMutation } from '@tanstack/react-query';
import { setRegisteredAddress } from '@Services/api/registeredAddress.api';
import type { MutationOnSuccess } from '@Types/util';

type SetRegisteredAddressOnSuccess = MutationOnSuccess<typeof setRegisteredAddress>;

export const useSetRegisteredAddress = (onSuccess: SetRegisteredAddressOnSuccess) =>
  useMutation({
    mutationFn: setRegisteredAddress,
    mutationKey: ['setRegisteredAddress'],
    onSuccess,
  });
